<template>
  <modal
    :title="
      setModel != undefined ? 'Update Dedicated Proxy' : 'Add Dedicated Proxy'
    "
    @close="$emit('close')"
  >
    <template #content>
      <Form
        method="dialog"
        v-slot="{ errors }"
        class="floating-labels p-1rem row"
        ref="form"
      >
        <div class="col-12">
          <formGroup
            :title="'Provider Name'"
            v-model="model.ProviderName"
            :errors="errors"
            :rules="{ required: true }"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-9">
          <formGroup
            :title="'IP'"
            v-model="model.IpAddress"
            :errors="errors"
            :rules="{ required: true }"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-3">
          <formGroup
            :title="'Port'"
            type="number"
            v-model="model.Port"
            :errors="errors"
            :rules="{ required: true }"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-6">
          <formGroup
            :title="'Username'"
            v-model="model.Username"
            :errors="errors"
            :rules="{ required: true }"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-6">
          <formGroup
            :title="'Password'"
            v-model="model.Password"
            :errors="errors"
            :rules="{ required: true }"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-auto">
          <formGroup
            :title="'Is Traffic Billable'"
            :as="'checkbox'"
            v-model="model.IsTrafficBillable"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-auto">
          <formGroup
            :title="'Active'"
            :as="'checkbox'"
            v-model="model.IsActive"
            :errors="errors"
            @keydown.enter="save"
          ></formGroup>
        </div>
      </Form>
    </template>
    <template #foot>
      <Btn
        class="btn-success btn-md"
        @click="save"
        :process="process"
        >{{
          setModel != undefined
            ? "Update Dedicated Proxy"
            : "Add Dedicated Proxy"
        }}</Btn
      >
    </template>
  </modal>
</template>

<script>
export default {
  props: {
    setModel: Object,
    operators: Array,
  },
  data() {
    return {
      model: {
        Id: null,
        ProviderName: "",
        IpAddress: "",
        Port: "",
        Username: "",
        Password: "",
        IsActive: true,
        IsTrafficBillable: false,
      },
      process: false
    };
  },
  created() {
    if (this.setModel != undefined) {
      this.model = { ...this.setModel };
    }
  },
  methods: {
    save() {
      this.$refs.form.validate().then((valid) => {
        if (valid.valid) {
          this.process = true;
          this.$appAxiosAdmin
            .post(`DedicatedProxies`, this.model)
            .then((response) => {
              this.process = false;
              this.$swal({
                icon: "success",
                title: "Success",
                text:
                  this.setModel != undefined
                    ? "The dedicated proxy has been successfully updated."
                    : "The dedicated proxy has been successfully added.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
              if (this.setModel != undefined) {
                this.$emit("update", response.data);
              } else {
                this.$emit("add", response.data);
              }
              this.$emit("close");
            })
            .catch((err) => {
              this.process = false;
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>

<style></style>
